import logoLight from "@/assets/logo-light.png";
import { STATS_TEXT } from "@/lib/stats";
import logoDark from "@/assets/logo-dark.png";
import profile1 from "@/assets/profile-1.jpg";
import profile2 from "@/assets/profile-2.jpg";
import profile3 from "@/assets/profile-3.jpg";
import profile4 from "@/assets/profile-4.jpg";

export const SITE_ORIGIN = "https://joinkcn.com";

/** Absolute URL for schema.org / social metadata. */
export const absoluteUrl = (path: string) =>
  path.startsWith("http") ? path : `${SITE_ORIGIN}${path}`;

export const BRAND = {
  name: "Kristan Cole Network",
  shortName: "KCN",
  tagline: "A path to wealth and freedom.",
  rallyCry: "Decide to do what others won't.",
  slogan: "Lead like a CEO. Build wealth that lasts.",
  kw: "A Network of KW Brokerages",
  description:
    `A path to wealth and freedom for agents. A national network of KW brokerages led by Kristan Cole, using the COLE Method in ${STATS_TEXT.markets} markets.`,
  founder: "Kristan Cole",
  areas: ["Arizona", "Alaska"],
  cities: ["Phoenix", "Scottsdale", "Mesa", "Anchorage", "Wasilla"],
  logos: {
    onWhite: logoLight,
    onDark: logoDark,
    blackOnWhite:
      "https://storage.googleapis.com/msgsndr/FqPJiF1AOHLn30eHsDf3/media/027fbdf5-8068-46cd-9f6c-744b65ee299a.png",
  },
  profilePics: [profile1, profile2, profile3, profile4],

  links: {
    roundTable: "/kcn-join-our-team",
    strategyCall: "/strategy-call",
    visibilityAudit: "/visibility-audit",
    rootsMethod: "https://go.northgeorgiapropertyexperts.com/snag",
    book: "https://www.amazon.com/Time-Downsize-Framework-Homeowners-Simpler/dp/B0H4C21LZC/",
    google: "https://share.google/XGo1qIbGO7ZrhbQxO",
  },
  socials: {
    facebook: "https://www.facebook.com/KristanColeNetwork/",
    linkedin: "https://www.linkedin.com/company/kristancolenetwork/",
    youtube: "https://www.youtube.com/@kristancolenetwork",
    instagram: "https://www.instagram.com/kristancolenetwork/",
  },
  stats: {
    transactions: "3,000+",
    volume: "$1B+",
    years: "40+",
    states: "AZ + AK",
  },
};

// Minimal primary navigation (mirrors Collective by Luxury Presence)
export const PRIMARY_NAV = [
  { to: "/why-join-kcn", label: "Why Join" },
  { to: "/the-cole-method", label: "The COLE Method™" },
  { to: "/meet-the-team", label: "About KCN" },
] as const;

// Full sitemap - used in footer
export const NAV = [
  { to: "/", label: "Home" },
  { to: "/why-join-kcn", label: "Why Join" },
  { to: "/the-cole-method", label: "The COLE Method™" },
  { to: "/value", label: "The Value" },
  { to: "/meet-the-team", label: "About KCN" },
  { to: "/kcn-worldwide", label: "Locations" },
  { to: "/results", label: "Results" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/blog", label: "MOTM Insights" },
  { to: "/resources", label: "Resources" },
  { to: "/contact-us", label: "Contact Us" },
] as const;
